
export const fixNumber = (num:number):String=>{

    let arr = num.toString().split('.');

    if(arr.length === 1){
        return `$${formatNumber(arr[0])}.00`;
    }
    else{

        const arr2 = arr[1].split('');
        if(arr[1].length === 1)
            return `$${formatNumber(arr[0])}.${arr[1]}0`;
        else
            return  `$${formatNumber(arr[0])}.${arr2.slice(0,2).join('')}`;
            
    }
}


const formatNumber = (num:string):String=>{
   
    let str = '';
    const len = num.length;
    const arr = num.split('');
    arr.reverse();

    for(let i = 0 ;i < len ;i++)
    {
        if(i > 0 && i % 3 === 0)
            str = `${arr[i]},${str}`;
        else
            str = arr[i] + str;

    }

    return str;
}

export const map = (value:number, 
    istart:number, 
    istop:number, 
    ostart:number, 
    ostop:number) => {

return ostart + (ostop - ostart) * ((value - istart) / (istop - istart));
}

export const clamp = (value:number , min:number , max:number) : number=>{
    if(value < min)
        return min;
    else if(value > max)
        return max;
    else
        return value;
}

export const calculateOds = (prizePool : number ,rektPool : number , rake : number ) : number=>{

    return (1-rake)*prizePool / rektPool;
}

export const formatTime = (time:number)=>{
    if (time < 0 || time === null || time === undefined || isNaN(time)) {
        return `00:00`
    }
    let min = Math.floor(time / 60).toString();
    if(min.length < 2)
        min = `0${min}`  

    let sec = (time % 60).toString();
    if(sec.length < 2)
        sec = `0${sec}`  
    
    return `${min}:${sec}`

}

export const  getRandomInt = (min : number, max: number) =>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
  }


 export const timer = (time : number)=>{

    return new Promise((resolve , reject)=>{

        setTimeout(() => {
            resolve(0);
        }, time);
    })
    
 }

 export const removeDupConfig = (arrayObj: any[], keyStr: string) => {
    return Object.values(arrayObj.reduce((result, item) => {
        const key = item[keyStr];
        result[key] = item
        return result
    }, {}))
 }